import { ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const globalSettingsIssuesExplicitFieldAssociationRoute = {
	name: ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST,
	path: '/jira/settings/issues/explicit-field-association',
};
